<div class="row d-flex flex-row mt-5">
  <span class="text-2sm font-medium text-gray-500 mb-3 p-0">{{
    getDisplayName(fields)
  }}</span>
  <div class="separator"></div>
</div>
